const ADMIN =
  "Ikra Marketing & Sales, ul. Legionowa 28/608, 15-281 Białystok, email: admin@ikra.org.pl, tel. +48 575 151 951";

export const LEGAL = {
  privacy: {
    kicker: "Dokumenty",
    title: "Polityka prywatności",
    updated: "15 września 2026",
    sections: [
      {
        title: "Administrator danych",
        paragraphs: [
          `Administratorem Twoich danych osobowych jest ${ADMIN} (dalej: „Ikra” lub „my”).`,
          "W każdej sprawie dotyczącej Twoich danych możesz napisać do nas na adres admin@ikra.org.pl.",
        ],
      },
      {
        title: "Jakie dane zbieramy",
        paragraphs: [
          "Przez formularz na stronie zbieramy wyłącznie dane, które sam nam podasz:",
        ],
        list: [
          "imię i nazwisko,",
          "numer telefonu,",
          "adres email,",
          "miasto.",
        ],
      },
      {
        title: "Cel i podstawa przetwarzania",
        paragraphs: [
          "Dane przetwarzamy po to, żeby skontaktować się z Tobą w sprawie rekrutacji i zaprosić Cię na spotkanie w naszym biurze. Podstawą przetwarzania jest Twoja zgoda (art. 6 ust. 1 lit. a RODO), którą wyrażasz wysyłając formularz, oraz nasz uzasadniony interes polegający na prowadzeniu rekrutacji (art. 6 ust. 1 lit. f RODO).",
          "Nie podejmujemy wobec Ciebie decyzji w sposób zautomatyzowany i nie profilujemy Twoich danych.",
        ],
      },
      {
        title: "Jak długo przechowujemy dane",
        paragraphs: [
          "Dane z formularza przechowujemy przez czas trwania procesu rekrutacyjnego, nie dłużej niż 12 miesięcy od ich przesłania. Po tym czasie dane usuwamy, chyba że wcześniej poprosisz o ich usunięcie albo dołączysz do zespołu i dane trafią do dokumentacji współpracy.",
        ],
      },
      {
        title: "Komu przekazujemy dane",
        paragraphs: [
          "Dostęp do danych mają wyłącznie osoby z naszego zespołu zaangażowane w rekrutację oraz dostawcy usług technicznych (hosting, poczta), którzy przetwarzają dane na nasze zlecenie. Nie sprzedajemy Twoich danych i nie przekazujemy ich innym firmom w celach marketingowych.",
        ],
      },
      {
        title: "Twoje prawa",
        paragraphs: ["Masz prawo do:"],
        list: [
          "dostępu do swoich danych i uzyskania ich kopii,",
          "poprawienia danych,",
          "usunięcia danych („prawo do bycia zapomnianym”),",
          "ograniczenia przetwarzania,",
          "cofnięcia zgody w dowolnym momencie, bez wpływu na zgodność z prawem przetwarzania przed cofnięciem,",
          "wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa).",
        ],
      },
      {
        title: "Pliki cookies i statystyki",
        paragraphs: [
          "Strona nie używa plików cookies do śledzenia ani do celów reklamowych. Możemy korzystać z podstawowych, anonimowych statystyk odwiedzin, które nie pozwalają na identyfikację konkretnej osoby.",
        ],
      },
      {
        title: "Linki do serwisów zewnętrznych",
        paragraphs: [
          "Na stronie znajdują się linki do naszego profilu na Instagramie oraz mapa Google. Po przejściu do tych serwisów obowiązują polityki prywatności ich operatorów (Meta Platforms, Google).",
        ],
      },
      {
        title: "Zmiany polityki",
        paragraphs: [
          "Możemy aktualizować tę politykę, gdy zmienią się przepisy albo sposób, w jaki działamy. Aktualna wersja jest zawsze dostępna na tej stronie razem z datą obowiązywania.",
        ],
      },
    ],
  },
  terms: {
    kicker: "Dokumenty",
    title: "Regulamin strony",
    updated: "15 września 2026",
    sections: [
      {
        title: "Postanowienia ogólne",
        paragraphs: [
          `Niniejszy regulamin określa zasady korzystania ze strony internetowej Ikra, prowadzonej przez ${ADMIN}.`,
          "Korzystając ze strony akceptujesz postanowienia regulaminu. Jeśli się z nimi nie zgadzasz, prosimy o niekorzystanie ze strony.",
        ],
      },
      {
        title: "Charakter strony",
        paragraphs: [
          "Strona ma charakter wyłącznie informacyjny i rekrutacyjny. Jej celem jest przedstawienie firmy, zespołu, roli Ambasadora Marki oraz umożliwienie kontaktu osobom zainteresowanym współpracą.",
          "Strona nie służy do sprzedaży produktów ani usług i nie stanowi oferty w rozumieniu Kodeksu cywilnego.",
        ],
      },
      {
        title: "Formularz kontaktowy",
        paragraphs: [
          "Wysłanie formularza jest bezpłatne i dobrowolne. Prosimy o podawanie prawdziwych danych, które pozwolą nam się z Tobą skontaktować.",
          "Wysłanie formularza nie oznacza zawarcia umowy ani gwarancji zaproszenia na spotkanie. Skontaktujemy się z Tobą telefonicznie lub mailowo, aby ustalić dalsze kroki.",
          "Zasady przetwarzania danych z formularza opisuje Polityka prywatności.",
        ],
      },
      {
        title: "Prawa autorskie",
        paragraphs: [
          "Treści, logo, zdjęcia zespołu i układ strony stanowią własność Ikra lub są wykorzystywane na podstawie licencji. Kopiowanie, rozpowszechnianie i wykorzystywanie ich bez naszej zgody jest zabronione.",
        ],
      },
      {
        title: "Odpowiedzialność",
        paragraphs: [
          "Dokładamy starań, żeby informacje na stronie były aktualne i rzetelne, ale nie gwarantujemy ich pełnej kompletności. Nie odpowiadamy za treści serwisów zewnętrznych, do których prowadzą linki ze strony (m.in. Instagram, Google Maps).",
          "Zastrzegamy sobie prawo do czasowego wyłączenia strony w celach technicznych.",
        ],
      },
      {
        title: "Zmiany regulaminu",
        paragraphs: [
          "Regulamin może być zmieniany. Zmiany obowiązują od dnia publikacji nowej wersji na stronie.",
        ],
      },
      {
        title: "Kontakt",
        paragraphs: [
          "Wszelkie pytania dotyczące regulaminu i działania strony kieruj na adres admin@ikra.org.pl albo dzwoń pod numer +48 575 151 951.",
        ],
      },
    ],
  },
};
